import {TagSchema} from 'constants/RegistryConstants';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SettingsIconDropdownItem} from 'nav/sidepanel/SettingsIconDropdown';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import legacyRunModal from 'ui-library/legacyRunModal';
import UnitSelectionModal from 'units/UnitSelectionModal';

import {SchemaField, UNIT_AWARE_FIELD_DEFINITIONS} from './SchemaFieldConstants';

export interface AdvancedSettingsIconProps {
  field: SchemaField;
  onUpdateField: (
    update: Pick<
      SchemaField,
      'decimalPrecision' | 'isUneditable' | 'unitApiIdentifier' | 'unitSymbol' | 'simpleRules'
    > & {isRequired?: boolean; isMulti?: boolean}
  ) => void;
  forFieldCreation?: boolean;
  itemType?: TagSchemaItemType | null; // needed to determine which options should be presented
  schema?: TagSchema;
  schemaNumItems?: number;
  schemaFieldSelectors?: Array<SchemaFieldSelector>;
  requestPopulateFromAnotherField?: (destinationField: SchemaField) => void;
  handleFieldMigration?: () => void;
  disableMultiSelect?: boolean;
}

export function getUnitDropdownOption(props: AdvancedSettingsIconProps): SettingsIconDropdownItem {
  const unitOptionDisabled = !UNIT_AWARE_FIELD_DEFINITIONS.includes(props.field.fieldType);
  const readOnly = props.forFieldCreation ? false : Boolean(props.field.unitApiIdentifier);
  const selectionWarningMessage = props.forFieldCreation
    ? "The unit of this field cannot be changed once it's been set and the field has been created."
    : "The unit of this field cannot be changed once it's been set.";

  return {
    name: 'Set unit...',
    disabled: unitOptionDisabled,
    onSelect: () => {
      legacyRunModal(UnitSelectionModal, {
        existingUnitId: props.field.unitApiIdentifier,
        existingUnitSymbol: props.field.unitSymbol,
        readOnly,
        readOnlyReason:
          "The unit of this field cannot be changed once it's been set. You may want to archive the field and create a new one instead.",
        selectionWarningMessage,
        onRequestSubmit: ({unitApiIdentifier, unitSymbol}) => {
          props.onUpdateField({unitApiIdentifier, unitSymbol});
        },
        forFieldCreation: props.forFieldCreation,
      });
    },
  };
}
